import {Icon} from '@wandb/components';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from 'react-aria-components';

import {useRunSearchQuery} from '../../generated/graphql';
import {runContainsFilter, toMongo} from '../../util/filters';

export const WBAgentRunMentionDropdown = ({
  entityName,
  onSelect,
  projectName,
  query,
}: {
  entityName: string;
  onSelect: (displayName: string, runId: string) => void;
  projectName: string;
  query: string;
}) => {
  const filters = query
    ? JSON.stringify(toMongo(runContainsFilter(query, 'run', 'displayName')))
    : '{}';
  const {data} = useRunSearchQuery({
    variables: {entityName, projectName, filters, first: 20},
  });

  const runs = data?.project?.runs?.edges.map(({node}) => node) ?? [];

  return (
    <div className="absolute bottom-full left-0 mb-4 w-full max-h-[200px] overflow-y-auto overscroll-none rounded-[5px] border border-moon-250 bg-white shadow-md">
      <div className="px-10 py-4 text-base font-semibold text-moon-800">
        Runs
      </div>
      {runs.map(run => (
        <Button
          key={run.id}
          className="flex w-full items-center gap-8 px-10 py-6 hover:bg-[#0d0f1208] text-left text-[15px] leading-[22px] font-normal"
          onClick={() => {
            if (run.displayName) {
              onSelect(run.displayName, run.id);
            }
          }}>
          <Icon icon="running-repeat" />{' '}
          <span className="truncate">{run.displayName}</span>
        </Button>
      ))}
      {runs.length === 0 && (
        <div className="px-12 py-8 text-moon-500">No runs found</div>
      )}
    </div>
  );
};
